import {
  isString,
  isNumber
} from './typeUtils.js'


const setStorage = function(key, obj, timeout) {
  // timeout 单位为秒，0，非数字，负数等表示永不过期
  let toSetString = ""
  let isNeedParse = "f"
  if (isString(obj)) {
    toSetString = obj
  } else {
    toSetString = JSON.stringify(obj)
    isNeedParse = "t"
  }
  let res = {
    data: toSetString,
    isNeedParse: isNeedParse,
  }
  if (isNumber(timeout) && timeout > 0) {
    res.timeout = new Date().valueOf() + timeout * 1000
  }
  localStorage.setItem(key, JSON.stringify(res))
}


const getStorage = function(key) {
  let res = JSON.parse(localStorage.getItem(key))
  if (res && res.timeout) {
    if (res.timeout - new Date().valueOf() < 0) {
      return null
    }
  }
  if (res && res.data) {
    try {
      if (res.isNeedParse === 't') {
        return JSON.parse(res.data)
      } else {
        return res.data
      }
    } catch(e) {
      return res.data
    }
  }
  return null
}


const setSessionStorage = function(key, obj) {
  // timeout 单位为秒，0，非数字，负数等表示永不过期
  let toSetString = ""
  let isNeedParse = "f"
  if (isString(obj)) {
    toSetString = obj
  } else {
    toSetString = JSON.stringify(obj)
    isNeedParse = "t"
  }
  let res = {
    data: toSetString,
    isNeedParse: isNeedParse,
  }
  sessionStorage.setItem(key, JSON.stringify(res))
}


const getSessionStorage = function(key) {
  let res = JSON.parse(localStorage.getItem(key))
  if (res && res.data) {
    try {
      if (res.isNeedParse === 't') {
        return JSON.parse(res.data)
      } else {
        return res.data
      }
    } catch (e) {
      return res.data
    }
  }
  return null
}


export {
  setStorage,
  getStorage,
  setSessionStorage,
  getSessionStorage
}



// WEBPACK FOOTER //
// ./src/utils/storageUtils.js